// Import external
import { Injectable } from '@angular/core';
import * as md5 from 'md5';

/**
 * A simple service allowing to retrieve gravatar uris from an email
 */
@Injectable()
export class GravatarService {
    constructor() {
    }

    public getGravatarUri(email: string, size = 60, fallback = 'mm') {
        return `https://www.gravatar.com/avatar/${md5(email)}?s=${size}&d=${fallback}`;
    }
}
